import { Component, OnInit, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Ticket, TicketStore } from 'src/app/stores/ticket.store';
import { Camera, CameraResultType } from '@capacitor/camera';
import {
  ActionSheetController,
  ModalController,
  Platform,
} from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-help-ticket',
  templateUrl: './help-ticket.page.html',
  styleUrls: ['./help-ticket.page.scss'],
})
export class HelpTicketPage implements OnInit {
  ticket_validations: FormGroup;
  validation_errors: any;
  ticket: Ticket;
  submitted = false;
  image: String = null;
  imageName: String = '';
  type: number = 0;
  @Input() pageType: number = 0;
  constructor(
    private ticketStore: TicketStore,
    private FormBuilder: FormBuilder,
    private translate: TranslateService,
    private authenticationStore: AuthenticationStore,
    private loaderService: LoaderService,
    private router: Router,
    public platform: Platform,
    private modalCtrl: ModalController
  ) {}
  ionViewWillEnter() {
    this.submitted = false;
  }
  async submit() {
    var ticket: Ticket = {
      title: this.ticket_validations.value.title,
      description: this.ticket_validations.value.description,
      type: this.type,
      img: this.imageName,
    };
    this.loaderService.showLoading();
    var response = await this.ticketStore.postTicket(ticket);
    if (this.platform.is('desktop')) this.dismissModal();
    this.loaderService.dismissLoading();
    this.submitted = true;
  }
  ngOnInit() {
    if (this.platform.is('mobile')) {
      if (this.router.getCurrentNavigation()?.extras?.state) {
        this.type = this.router.getCurrentNavigation()?.extras?.state?.type;
      }
    } else {
      this.type = this.pageType;
    }
    this.getErrors();
    this.ticket_validations = this.FormBuilder.group({
      title: new FormControl('', Validators.compose([Validators.required])),
      description: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      type: new FormControl(),
      img: new FormControl(),
    });
  }

  getErrors() {
    this.validation_errors = {
      title: [
        { type: 'required', message: 'ACCOUNT_PAGE.ADD_SUBJECT_ERROR' },
        { type: 'minlength', message: 'ACCOUNT_PAGE.SUBJECT_LENGTH' },
      ],
      description: [
        { type: 'required', message: 'ACCOUNT_PAGE.ADD_DESC' },
        { type: 'minlength', message: 'ACCOUNT_PAGE.DESC_LENGTH' },
      ],
    };
  }
  async imageAction() {
    const image = await Camera.getPhoto({
      quality: 50,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
    });
    this.image = image.dataUrl;
    this.loaderService.showLoading();
    try {
      var imageUrl = await this.authenticationStore.imageUpload(image.dataUrl);
      this.loaderService.dismissLoading();
      this.imageName = imageUrl.data.name;
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data
          ? error.error.data
          : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
        'bottom',
        'danger'
      );
    }
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
